<template>
  <div class="overview">
    <div
      v-if="isAdmin"
      class="mode-switch"
      role="group"
      aria-label="Dashboard mode"
    >
      <button
        type="button"
        class="mode-btn"
        :class="{ 'mode-btn--active': activeMode === 'admin' }"
        :aria-pressed="activeMode === 'admin' ? 'true' : 'false'"
        @click="setMode('admin')"
      >
        <i class="now-ui-icons business_chart-bar-32" aria-hidden="true"></i>
        <span>Admin</span>
      </button>
      <button
        type="button"
        class="mode-btn"
        :class="{ 'mode-btn--active': activeMode === 'employee' }"
        :aria-pressed="activeMode === 'employee' ? 'true' : 'false'"
        @click="setMode('employee')"
      >
        <i class="now-ui-icons users_single-02" aria-hidden="true"></i>
        <span>Employee</span>
      </button>
    </div>

    <Admindashboard v-if="activeMode === 'admin'" />
    <EmployeeDashboard v-else />
  </div>
</template>

<script>
import EmployeeDashboard from "./EmployeeDashboard.vue";
import Admindashboard from "./Admindashboard.vue";

const MODE_STORAGE_KEY = "dashboardMode";

export default {
  name: "Overview",
  components: {
    EmployeeDashboard,
    Admindashboard,
  },
  data() {
    return {
      mode: this.readStoredMode(),
    };
  },
  computed: {
    isAdmin() {
      const user = this.$store.state.auth.user;
      return !!user && user.role === "admin";
    },
    activeMode() {
      return this.isAdmin ? this.mode : "employee";
    },
  },
  watch: {
    isAdmin(isAdmin) {
      if (!isAdmin) this.setMode("employee", false);
    },
  },
  methods: {
    readStoredMode() {
      try {
        return localStorage.getItem(MODE_STORAGE_KEY) === "employee"
          ? "employee"
          : "admin";
      } catch (e) {
        return "admin";
      }
    },
    setMode(mode, persist = true) {
      this.mode = mode;
      if (!persist) return;
      try {
        localStorage.setItem(MODE_STORAGE_KEY, mode);
      } catch (e) {
        // Storage unavailable (private mode / quota) — the switch still works for this session.
      }
    },
  },
};
</script>

<style scoped>
.overview {
  width: 100%;
}

.mode-switch {
  display: flex;
  gap: 4px;
  width: fit-content;
  margin: 0 auto 18px;
  padding: 4px;
  background: #e8eceb;
  border-radius: 99px;
}

.mode-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 20px;
  border: none;
  border-radius: 99px;
  background: transparent;
  color: #55635f;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}

.mode-btn i {
  font-size: 14px;
}

.mode-btn:hover {
  color: #3d5851;
}

.mode-btn--active {
  background: #3d5851;
  color: #fff;
}

.mode-btn--active:hover {
  color: #fff;
}

@media (max-width: 640px) {
  .mode-switch {
    width: 100%;
  }

  .mode-btn {
    flex: 1;
    justify-content: center;
    padding: 7px 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Overview.vue